<section id="regras" class="folha-back">
  <div class="folha-rules">
    @if (familyRules | async) {
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading">Regras da Família</h2>
            <hr class="my-4" />
          </div>
          <div class="col-lg-12">
            <span class="mb-4 text-regulamento">
              <h3>Grupo Família</h3>
              <p>
                O grupo <strong>"Família"</strong> será o único grupo gerido pelos juízes do BolCó com o intuito de
                confraternizar com aqueles que forem convidados. O criador do grupo poderá convidar outras pessoas para
                participar da competição. Lembrando que elas deverão acessar o site
                <a href="https://bolco.com.br">https://bolco.com.br</a> e realizar o login com o mesmo endereço de email
                utilizado no convite feito pelo administrador do grupo.
              </p>
            </span>
          </div>
        </div>
      </div>
    }
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading">
            Regras
            @if (familyRules | async) {
              <span> Gerais</span>
            }
          </h2>
          <hr class="my-4" />
        </div>
        <div class="col-lg-12">
          <span class="mb-4 text-regulamento">
            <p>
              O Bolão "Rumo ao Hexa - A revanche", referente à Copa do Mundo de 2026, é uma competição de prognósticos
              esportivos, sem fins lucrativos, com o intuito de promover o lado psicosocioesportivo de seus
              participantes. Os palpites serão para toda a competição da Copa do Mundo, cujos jogos já estão
              pré-estabelecidos.
            </p>
            <h3>Inscrição</h3>
            <p>
              O apostador deverá acessar o site <a href="https://bolco.com.br">https://bolco.com.br</a> pelo computador
              ou celular e realizar o login. Existem três formas de autenticação: usando o endereço de email e senha ou
              pelas contas do Facebook ou Google. Os participantes da
              <a href="https://e2018.bolco.com.br/">quinta edição do bolão</a>, em 2018, já estão automaticamente
              cadastrados na plataforma.
            </p>
            <h3>Grupo</h3>
            <p>
              O participante poderá participar em até cinco grupos simultâneos, com limite máximo de 250 pessoas cada.
              Cada grupo possui três perfis que definem quais ações o participante pode realizar:
            </p>
            <ul>
              <li>
                <strong>Comum:</strong> O usuário com esse perfil pode realizar palpite nos jogos e está participando da
                classificação do grupo
              </li>
              <li>
                <strong>Moderador:</strong> Possui as mesmas funcionalidades do "comum" e pode convidar outras pessoas
                para integrar ao grupo
              </li>
              <li>
                <strong>Administrador:</strong> Possui as mesmas funcionalidades do perfil "moderador" e pode remover
                integrantes do grupo
              </li>
            </ul>
            <h3>Palpites</h3>
            <p>
              Os prognósticos deverão ser efetuados até o início de cada partida, por este site na opção "Jogos". O
              palpite de um jogador ficará invisível aos outros participantes até o início de cada jogo, quando a aposta
              de todos os participantes do grupo ficam disponíveis para serem consultadas para quem assim o quiser. A
              consulta poderá ser feita ao selecionar o nome do participante na listagem do grupo ou receber por e-mail,
              no início de cada partida caso o participante assim o quiser. Essas são algumas formas de todos os
              apostadores atestarem a integridade do sistema.
            </p>
            <p>
              Na segunda fase, o palpite será referente ao placar no fim do tempo normal do jogo (90 minutos) mais os
              acréscimos do segundo tempo. Não serão considerados os placares da prorrogação e da disputa dos pênaltis
              para a aferição dos pontos.
            </p>
            <h3>Da Pontuação</h3>
            <p>A pontuação adotada será a seguinte:</p>
            <ul>
              <li><strong>A: Placar Correto</strong>: acerto integral do placar do jogo</li>
              <li>
                <strong>B: Vitória simples</strong>: Indicação do time vencedor e acerto somente do nº de gols do
                vencedor da partida
              </li>
              <li><strong>C: Empate incerto</strong>: acerto do empate no jogo, mas com placar incorreto</li>
              <li>
                <strong>D: Derrota simples</strong>: Indicação do time vencedor e acerto somente do nº de gols do
                perdedor da partida
              </li>
              <li>
                <strong>E: Saldo de gols</strong>: Acerto do saldo de gols entre os dois times lembrando que o time
                vencedor deve coincidir
              </li>
              <li>
                <strong>F: Indicativo do vencedor</strong>: indicação do vencedor e perdedor, com desacerto do número de
                gols marcados por ambos
              </li>
            </ul>
            <br />
            <span>A pontuação é escalonada e seguirá as seguintes quantidades:</span><br /><br />
          </span>
        </div>
        <div class="col-lg-12 text-center">
          <table class="Grupos" aria-label="Pontuações">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">Fase de Grupos</th>
                <th scope="col">Oitavas-de-Final</th>
                <th scope="col">Quartas-de-Final</th>
                <th scope="col">Semi-Final</th>
                <th scope="col">Final e 3º Lugar</th>
              </tr>
            </thead>
            <tbody>
              <tr class="tr-cheio">
                <td class="classe_titulo">A: Placar Correto</td>
                <td>12</td>
                <td>15</td>
                <td>18</td>
                <td>20</td>
                <td>25</td>
              </tr>
              <tr>
                <td class="classe_titulo">B: Vit&oacute;ria simples</td>
                <td>9</td>
                <td>10</td>
                <td>12</td>
                <td>15</td>
                <td>18</td>
              </tr>
              <tr class="tr-cheio">
                <td class="classe_titulo">C: Empate incerto</td>
                <td>8</td>
                <td>9</td>
                <td>10</td>
                <td>13</td>
                <td>16</td>
              </tr>
              <tr>
                <td class="classe_titulo">D: Derrota simples</td>
                <td>7</td>
                <td>8</td>
                <td>9</td>
                <td>12</td>
                <td>15</td>
              </tr>
              <tr class="tr-cheio">
                <td class="classe_titulo">E: Saldo de gols</td>
                <td>5</td>
                <td>6</td>
                <td>7</td>
                <td>9</td>
                <td>12</td>
              </tr>
              <tr>
                <td class="classe_titulo">F: Indicativo do vencedor</td>
                <td>3</td>
                <td>4</td>
                <td>5</td>
                <td>7</td>
                <td>9</td>
              </tr>
            </tbody>
          </table>
          <br /><br />
        </div>
        <div class="col-lg-12">
          <p>
            Em caso de empate na soma dos pontos, será nomeado vencedor o participante que tiver o maior número de
            acertos na seguinte ordem:
          </p>
          <ol>
            <li>Placar correto</li>
            <li>Vitória simples</li>
            <li>Empate incerto</li>
            <li>Derrota simples</li>
            <li>Saldo de gols</li>
            <li>Indicativo do vencedor</li>
          </ol>
          <p>Permanecendo ainda o empate, o prêmio será dividido entre os “cagões” que conseguiram essa proeza.</p>
        </div>
      </div>
    </div>
  </div>
</section>
